/**
 * add-v2 lives in its own namespace. The old `/rubialert/add-alert` and
 * `/rubialert/upload-alert` still resolve, but nothing links to them any more.
 *
 * The start screen and the form are separate routes because both need to be linkable: `:bulletinId`
 * opens the form directly, and the report hand-off (`?token=`) links to the **start** screen — it
 * has no bulletin to open yet, and the endpoint that creates one answers with an id, so it ends up
 * on the edit route like every other entry that creates its row server-side (decision 53).
 */
export const BULLETIN_START_ROUTE = "/rubialert/bulletins/new";
export const BULLETIN_FORM_ROUTE = "/rubialert/bulletins/new/form";

/**
 * Where RubiREPORT sends an officer who asked for a bulletin — the one link into add-v2 from outside
 * it, which is why the parameter's name lives here rather than in either caller.
 */
export const bulletinFromReportPath = (token: string): string =>
  `${BULLETIN_START_ROUTE}?token=${encodeURIComponent(token)}`;

/**
 * Editing an existing bulletin. **The route is the mode** — `BulletinFormPage` takes no `mode`
 * prop, it reads `:bulletinId`, so these two paths are the whole of the create/edit distinction.
 *
 * All three Edit affordances — the DRAFT banner's button in `DisplayAlert`, the toolbar's in
 * `DisplayAlertTopButton`, and the single-bulletin page's in `DisplayAlertSingleTopButton` — call
 * `bulletinEditPath` directly. Drafts and published bulletins both land here: the form is the same
 * document either way, and the only difference is what the footer offers (decision 34). The old
 * `/rubialert/{drafts,alerts}/:id/single/edit` routes still resolve, but nothing links to them.
 */
export const BULLETIN_EDIT_ROUTE = "/rubialert/bulletins/:bulletinId/edit";

export const bulletinEditPath = (bulletinId: number | string): string =>
  `/rubialert/bulletins/${bulletinId}/edit`;
